import { memo } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { Tooltip, Typography } from '@mui/material'
import styles from './sidebar.module.scss'

export const NavItem = memo(
	({
		icon,
		label,
		to,
		onClick,
		dataTestId,
		isSidebarOpen,
		isIconComponent = false,
		matchPrefix = false,
	}) => {
		const { pathname } = useLocation()
		const isActive = matchPrefix
			? pathname === to || pathname.startsWith(`${to}/`)
			: pathname === to

		return (
			<li data-cy={dataTestId}>
				<Tooltip
					title={label}
					placement="right"
					disableInteractive
					arrow
				>
					<Link
						to={to}
						onClick={onClick}
						className={isActive ? styles.activeNavItem : ''}
					>
						{isIconComponent ? (
							icon
						) : (
							<img src={icon} alt={`${label}-icon`} />
						)}
						{isSidebarOpen && (
							<Typography
								variant="body1"
								className={`${styles.linkText} linkText`}
							>
								{label}
							</Typography>
						)}
					</Link>
				</Tooltip>
			</li>
		)
	}
)
